<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import { fade } from "svelte/transition";
  import Setup from "../../modals/ProcessInvoices/Setup.svelte";
  import PremiumWelcome from "../../modals/Paywall/PremiumWelcome.svelte";
  import { subscriptionModal } from "../../stores/subscription-modal-store";
  import { track } from "../../helpers/mixpanel";
  import InvoiceUploadModal from "../invoices/InvoiceUploadModal.svelte";
  import { createModal } from "./createModal";

  const SETUP_VARIANTS = ["forwarding-setup", "invoice-upload"];
  const { contentAttrs, underlayAttrs, open: isModalOpen, ...modal } = createModal();

  function onClose() {
    subscriptionModal.close();
  }
  function onComplete() {
    subscriptionModal.invoiceUploadComplete();
  }

  function onOpenNewUploadInvoiceModal() {
    subscriptionModal.close();
    modal.onOpen();
  }

  function onContinue() {
    onOpenNewUploadInvoiceModal();
    track("signup_success_screen_cta_click");
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === "Escape") {
      onClose();
    }
  }

  onMount(() => {
    window.addEventListener("keydown", handleKeydown);
  });

  onDestroy(() => {
    window.removeEventListener("keydown", handleKeydown);
  });

  $: if ($subscriptionModal.isVisible && $subscriptionModal.variant === "subscription-premium") {
    track("signup_success_screen_view");
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
{#if $subscriptionModal.isVisible && $subscriptionModal.variant}
  <div class="modal-container" on:click={onClose}>
    <div class="underlay" in:fade|global={{ duration: 200 }} out:fade|global={{ duration: 200 }} />
    <div
      class="active-modal"
      on:click|stopPropagation
      in:fade|global={{ duration: 200 }}
      out:fade|global={{ duration: 200 }}
    >
      <!-- variant name not the most clear...but invoice-upload/<Setup /> includes the onboarding flow/paywall -->
      {#if SETUP_VARIANTS.includes($subscriptionModal.variant)}
        <div in:fade|global={{ duration: 300 }} class="setup-wrapper">
          <Setup {onComplete} {onClose} variant={$subscriptionModal.variant} />
        </div>
      {:else if $subscriptionModal.variant === "subscription-premium"}
        <PremiumWelcome {onContinue} {onClose} />
      {/if}
    </div>
  </div>
{/if}

{#if $isModalOpen}
  <InvoiceUploadModal
    contentAttrs={$contentAttrs}
    underlayAttrs={$underlayAttrs}
    open={$isModalOpen}
    contentAction={modal.content}
    onClose={modal.onClose}
  />
{/if}

<style>
  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .setup-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 1 100%;
  }

  .modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
  }

  .active-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 500ms;
    -webkit-transition: all 500ms;
    flex-direction: row;
    border-radius: 8px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: relative;
    z-index: 1;
  }

  .underlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: -1;
  }
</style>
